import React, { useState, useEffect } from "react";
import { Tooltip, Button } from "antd";
import ModalIssueApprove from "../../../../../components/modal/walletIssue/modalIssueApprove";
import { CheckCircleOutlined } from "@ant-design/icons";
import moment from "moment";
import * as orderManagementActions from "../../../../../redux/actions/orderManagement.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
const OrderIssueTable = (props) => {
  const [postDataOrderIssue, setPostDataOrderIssue] = useState(null);
  const [MBtnLoading, setMBtnLoading] = useState(false);
  useEffect(() => {
    if (props.OrderID) {
      postListsIssuerefresh();
    }
  }, [props.OrderID]);

  useEffect(() => {
    setPostDataOrderIssue(props.taskIssueData);
  }, [props.taskIssueData]);

  const postListsIssuerefresh = async () => {
    try {
      setMBtnLoading(true);
      await props.orderManagementActions.putOrderDetailIssuesAction( props.OrderID );
    } catch (e) {} finally {
      setMBtnLoading(false);
    }
  };

  const [showModalApproveIssue, setshowModalApproveIssue] = useState(false);
  // const [showModalApproveIssueID, setshowModalApproveIssueID] = useState(false);
  const showIssueApprove = (value) => {
    // setshowModalApproveIssueID(value);
    setshowModalApproveIssue(true);
  };

  return postDataOrderIssue ? (
    <div className="customTable">
      <table>
        <ModalIssueApprove
          visible={showModalApproveIssue}
          setvisible={setshowModalApproveIssue}
          issueData={postDataOrderIssue}
          postListsrefresh={postListsIssuerefresh}
        />
        <thead>
          <tr>
            <th>Delivery</th>
            <th>Created at</th>
            <th>Uploaded at</th>
            <th>Issue</th>
            <th>Reason</th>
            <th>Approved Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {(postDataOrderIssue.task &&
                postDataOrderIssue.task.order_id != "") ||
              null
                ? postDataOrderIssue.task.order_id
                : "-"}
            </td>
            <td>
              {
                postDataOrderIssue.task
                  ? moment(postDataOrderIssue.created_at).format("h:mm A")
                  : "-"
                // const STview = moment(proId.created_at).format("DD MMMM, yyyy, h:mm A");
              }
            </td>
            <td>
              {postDataOrderIssue.updatedTime != null
                ? moment(postDataOrderIssue.updatedTime).format("h:mm A")
                : "-"}
            </td>
            <td>{postDataOrderIssue ? postDataOrderIssue.type : "-"}</td>
            <td>{postDataOrderIssue ? postDataOrderIssue.reason : "-"}</td>
            <td>
              {postDataOrderIssue.approved === true ? (
                "Resolved"
              ) : postDataOrderIssue.approved === false ||
                postDataOrderIssue.updatedBy != null ? (
                "Rejected"
              ) : (
                <Tooltip title="Approve Issue">
                  <Button
                    onClick={() => showIssueApprove(postDataOrderIssue.id)}
                    disabled={MBtnLoading}
                  >
                    <CheckCircleOutlined />
                  </Button>
                </Tooltip>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ) : (
    "-"
  );
};

const mapStateToProps = (state) => {
  return {
    taskIssueData: state.OrderManagementReducer.taskIssueData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    orderManagementActions: bindActionCreators( orderManagementActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderIssueTable);
